import React from 'react'
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles'
import { Link, LinkProps } from 'react-router-dom'
import Button, { ButtonProps } from '@material-ui/core/Button'
import classNames from 'classnames'

type Props = ButtonProps & LinkProps & {
  block?: boolean,
  className?: string
}

const styles = createStyles({
  block: {
    display: 'block',
    width: '100%'
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const NavButton: React.SFC<InjectedProps> = ({ classes, block, className, ...props }) => (
  <Button
    // TODO
    // tslint:disable-next-line:no-any
    component={Link as any}
    className={classNames({ [classes.block]: block }, className)}
    {...props}
  />
)

export default withStyles(styles)(NavButton)
